import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { GridResultsScreen } from '../Grid/GridResultsScreen';
import FormularioUsuarios from '../Formulario/container';
import {EuiSpacer} from '@elastic/eui';
import { ActionType, CREATE, UPDATE, ADDCENTERS } from './constants';
import { Action } from '../../../../components/Menus/interface';
import { Menu } from '../../../../components/Menus';
import ModalApp from '../../../../components/Modal';
import ModalYesNo from '../../../../components/Modal/YesNo';
import { ModalSelectorCentros } from '../SelectorCentros';

interface Props {
  data: any;
  handleCreate(usuario: any): any;
  handleRemove(usuario: any): any;
  handleUpdate(loginOld:string,usuario: any): any;
  handleAddCentros(user:string,centros:string):any;
}

const UsuariosScreen = (props: Props) => {
  const ref:any = useRef();
  let { data, handleCreate, handleRemove, handleUpdate, handleAddCentros } = props;
  let [isModalVisible, setIsModalVisible] = useState(false);
  let [openRemoveModal, setOpenRemoveModal] = useState(false);
  let [selected, setSelected] = useState<any>(undefined);
  let [actionType, setActionType] = useState<ActionType>(CREATE);

  useEffect(() => { closeModal(); setSelected(undefined); if(openRemoveModal){setOpenRemoveModal(false)}}, [data]);

  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);

  const prepareCreate = useCallback(() => {
    setActionType(CREATE);
    showModal();
  },[])

  const prepareEdit = useCallback(() => {
    setActionType(UPDATE);
    showModal();
  },[])

  const prepareAddCentros = useCallback(() => {
    setActionType(ADDCENTERS);
    showModal();
  },[])

  const onCreate = useCallback((newData: any) => {
    if (newData && handleCreate) {
      handleCreate(newData)
    }
  },[handleCreate])

  const onAddCentros = useCallback((newData: string) => {
      selected && handleAddCentros(selected.login,newData)
  },[selected,handleAddCentros])

  const onUpdate = useCallback((newData: any) => {
    if (handleUpdate && (newData && selected)) {
      handleUpdate(selected.login,newData)
    }
  },[selected,handleUpdate])

  const onRemove = useCallback(() => {
    if (selected && handleRemove) {
      if(selected!==undefined){
        setOpenRemoveModal(true)
      }else{
        handleRemove(selected);
      }
    }
  },[selected, handleRemove])

  const onSelected = (selection: any) => {
    setSelected(selection[0])
  }

  const onExport = () =>{
    ref.current && ref.current.onExport();
  }

  const getSelected = useMemo(() =>{
    return actionType.tipo === "U" ? selected : undefined;
  },[actionType,selected])

  const getHandle = useCallback(() =>{
    if(actionType.tipo === "I"){
      return onCreate
    }else{
      return onUpdate
    }
  },[actionType,onCreate,onUpdate])

  const onConfirmRemove = (response:any) => {
    if(response!==undefined && response === true){
      handleRemove(selected);
    }else{
      setOpenRemoveModal(false)
    }
  }

  const getLabelAddCentros = useCallback(() =>{
    return selected ? (selected.tieneCentros) ? "Modificar Centros" : "Agregar Centros" : "Centros"
  },[selected])

  const Actions: Action[] = useMemo(()=> [
    {handle:prepareAddCentros,text:getLabelAddCentros(),size:"s", isDisabled:(selected===undefined), color:"warning"},
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false},
    {handle:onRemove,text:"Eliminar Selección",color:"danger",size:"s", isDisabled:(selected===undefined)},
    {handle:prepareEdit,text:"Editar Selección",color:"secondary",size:"s",isDisabled:(selected===undefined)},
    {handle:prepareCreate,text:"Nuevo Usuario",color:"primary",size:"s", isDisabled:false}
  ],[selected,onRemove,prepareEdit,prepareCreate,prepareAddCentros,getLabelAddCentros])

  const contentModal = useCallback(() =>  <FormularioUsuarios handle={getHandle()} selected={getSelected} onClose={closeModal}/>,[getHandle,getSelected])
  const modal = useMemo(() => {

      switch (actionType.tipo) {
        case 'I':
        case 'U':
          return <ModalApp isOpen={isModalVisible} title={actionType.title} onClose={closeModal} content={contentModal()}/> 
        case 'A':
          return <ModalSelectorCentros isOpen={isModalVisible} user={selected} onAddCentros={onAddCentros} onClose={closeModal}/>
      }
  }
  ,[isModalVisible,actionType,contentModal])

  const getView = useMemo(() => {
    return (
      <>
        <Menu actions={Actions}/>
        <EuiSpacer size="s" />
        <GridResultsScreen
          data={data}
          onSelected={onSelected}
          selector={false}
          menu={false}
          ref={ref}
        />
        {modal}
        {openRemoveModal ? <ModalYesNo onClose={onConfirmRemove} isOpen={openRemoveModal}/> : null}
      </>
    )
  },[data, modal, onSelected, openRemoveModal, onConfirmRemove])

  return (
    <>
      {getView}
    </>
);
};

export default UsuariosScreen;